import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ShortAddress } from '@common/index';

@Pipe({
    name: 'bigNumber'
})
export class BigNumberPipe extends DecimalPipe implements PipeTransform
{
    transform(value: string, ...args): any
    {
        let result;

        if (1e20 <= Number(value))
        {
            result = Number(value).toLocaleString('fullwide', { useGrouping: true });
        }
        else
        {
            return super.transform(value, ...args);
        }

        return result;
    }
}
